module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"category":"Kategorie","dates":"Termine","events":"Seminare","number":"Nummer","search":"Suche","subCategory":"Unterkategorie","title":"Bezeichnung"},"en":{"category":"Category","dates":"Dates","events":"Events","number":"Number","search":"Search","subCategory":"Sub category","title":"Title"}}')
  delete Component.options._Ctor
}
